import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { RestQuery } from '../../rest/utilities/rest-query'

@Mapped({}, ['timestamps'])
export class NoticeCategory extends Mappable {
  id!: number
  name!: string
  created!: Date
  updated!: Date

  static create<Data>(attrs: Data) {
    return new NoticeCategory().map(attrs)
  }
}

interface Filters {
  keywords?: string
  archive?: string
}
type Ordering = 'name' | '-name'

export class NoticeCategoryQuery extends RestQuery<Filters, Ordering> {}
